<!-- SI NO TE ASSIGNAT UN AGENT, EL QR ET PORTA A LA LLISTA DE QRs D'UNA RUTA. SI TE AGENT, ET PORTA A LA PANTALLA DE GESTIÓ EXTERNA DEL CMR (shared.cmr.agent.qr.page) -->
<div *ngIf="uuidQR">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div class="img"><img [src]="formatDocumentQRCode" /></div>
        <div class="help-qr">{{ helpResource | translate }}</div>
    </div>
</div>